import { useEffect, useRef } from 'react';
import { pushBackHandler } from './telegram';

/**
 * Пока `active`, системная кнопка «назад» Telegram закрывает этот слой.
 *
 * Несколько слоёв разом (карточка → пикер внутри неё) складываются в стек:
 * «назад» закрывает верхний. `handler` берётся через ref, чтобы не
 * переподписываться на каждый рендер — только на смену `active`.
 */
export function useBackButton(active: boolean, handler: () => void) {
  const ref = useRef(handler);
  ref.current = handler;

  useEffect(() => {
    if (!active) return;
    return pushBackHandler(() => ref.current());
  }, [active]);
}
